<div class="remax-modal has-pos-fix is-flex has-flex-content-center has-flex-align-center" *ngIf="shouldShowModal" [class.remax-modal--redesign]="isReDesign" >
  <div class="background full-width full-height has-pos-fix"></div>
  <div class="content has-pos-rel" #modalRef [class.full-expansion]="isFullHeight" [ngClass]="size" [class.isOnLandingPage]="isLandingPage" (focusout)="checkFocus($event)">
    <div tabindex="0" role="presentation" class="hidden-anchor" #hiddenAnchor [attr.aria-label]="'aria.modalOpened' | translate"></div>
    <button class="btn-link close-ic has-pos-abs" (click)="closeModal.emit()" [title]="'aria.closeModal' | translate"><i class="material-icons">close</i></button>
    <ng-container [ngTemplateOutlet]="templateRef"></ng-container>
  </div>
</div>
